import { Settings } from "./settings";

export const PixiSettings = {
  REELSET_LAYOUT_CONFIGS: {
    MOBILE_PORTRAIT: {
      paddingSides: Settings.SYMBOL_WIDTH * 1.1,
      paddingTop: Settings.SYMBOL_HEIGHT * 3.5,
      paddingBottom: Settings.SYMBOL_HEIGHT * 4,
    },
    MOBILE_LANDSCAPE: {
      paddingSides: Settings.SYMBOL_WIDTH * 4.0,
      paddingTop: Settings.SYMBOL_HEIGHT * 1.0,
      paddingBottom: Settings.SYMBOL_HEIGHT * 1.0,
    },
    TABLET_PORTRAIT: {
      paddingSides: Settings.SYMBOL_WIDTH * 3,
      paddingTop: Settings.SYMBOL_HEIGHT * 3.5,
      paddingBottom: Settings.SYMBOL_HEIGHT * 3.5,
    },
    TABLET_LANDSCAPE: {
      paddingSides: Settings.SYMBOL_WIDTH * 5.5,
      paddingTop: Settings.SYMBOL_HEIGHT,
      paddingBottom: Settings.SYMBOL_HEIGHT,
    },
    SMALL_DESKTOP: {
      paddingSides: Settings.SYMBOL_WIDTH * 4,
      paddingTop: Settings.SYMBOL_HEIGHT,
      paddingBottom: Settings.SYMBOL_HEIGHT,
    },
    DESKTOP: {
      paddingSides: Settings.SYMBOL_WIDTH * 1.5,
      paddingTop: Settings.SYMBOL_HEIGHT,
      paddingBottom: Settings.SYMBOL_HEIGHT,
    },
  },

  ORIENTATION: {
    PORTRAIT: "PORTRAIT",
    LANDSCAPE: "LANDSCAPE",
  },

  DEVICE: {
    MOBILE: "MOBILE",
    TABLET: "TABLET",
    DESKTOP: "DESKTOP",
  },

  /**
   * Centralized font style presets.
   * Only visual appearance (fill, stroke, gradient, shadow) — not size/weight/layout.
   * Change these once per game to restyle all text across every component.
   */
  FONT_STYLES: {
    /**
     * PRIMARY — Single-layer gold gradient text with drop shadow.
     * Used by: WinAnimation, IntroPopup, BuyBonusController
     */
    PRIMARY: {
      fontFamily: "Noto Sans, Arial, sans-serif",
      fill: ["#fcb842", "#ffe7a7", "#ffe764"],
      fillGradientType: 0,
      stroke: "#faedb8",
      strokeThickness: 2,
      dropShadow: true,
      dropShadowColor: "#b24c00",
      dropShadowDistance: 3,
      dropShadowBlur: 0,
      dropShadowAlpha: 1,
      dropShadowAngle: Math.PI / 2,
    },

    /**
     * SECONDARY — Single-layer text with drop shadow.
     * Used by: ReelFrontController (LINES text)
     */
    SECONDARY: {
      fontFamily: "Noto Sans, Arial, sans-serif",
      fill: "#d6dbff",
      stroke: "#ffffff",
      strokeThickness: 2,
      dropShadow: true,
      dropShadowColor: "#085fac",
      dropShadowDistance: 3,
      dropShadowBlur: 0,
      dropShadowAlpha: 1,
      dropShadowAngle: Math.PI / 2,
    },

    /**
     * SLOT_TEXT — Shared layout preset for all spine-slot-attached text.
     * Defines fontWeight, fontSize, padding, and resolution so every
     * slot text (IntroPopup cards, max win, tap-to-start, WinAnimation button)
     * looks identical. Spread PRIMARY first, then SLOT_TEXT to override layout props.
     */
    SLOT_TEXT: {
      fontWeight: "400",
      fontSize: 38,
      align: "center",
      letterSpacing: 0,
      padding: 10,
      resolution: 1,
    },
  },
};
